import { get } from 'lodash';

export const exceedRetentionPeriod = (error: any) =>
  get(error, 'response.data.exceed_data_retention_period');

export const useECOServerErrorMessage = (error?: any) => {
  if (!error) return undefined;

  if (exceedRetentionPeriod(error)) {
    const message = get(error, 'response.data.message');
    return message;
  }

  return undefined;
};
